import { render, staticRenderFns } from "./ChartjsDoughnutChart.vue?vue&type=template&id=c5d8cb78&scoped=true&"
import script from "./ChartjsDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsDoughnutChart.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChartjsDoughnutChart.vue?vue&type=style&index=1&id=c5d8cb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8cb78",
  null
  
)

export default component.exports